import { render, staticRenderFns } from "./InformaceoServisuDleNS.vue?vue&type=template&id=f20a2a26&"
import script from "./InformaceoServisuDleNS.vue?vue&type=script&lang=ts&"
export * from "./InformaceoServisuDleNS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports